"use client";

import { useEffect, useRef } from "react";
import { useTranslations } from "next-intl";
import { versionUpdateToast } from "@/lib/toast";
import { useAppVersion } from "@sukha/query";
import { APP_VERSION } from "@/constants/version";

// Polls the server for the latest version and shows a top-right toast
// prompting the user to refresh when a newer version is available.
export default function AppVersionWatcher() {
  const t = useTranslations("System.update");
  const { data: serverVersion } = useAppVersion(15 * 60 * 1000); // 15m
  const shownRef = useRef(false);

  useEffect(() => {
    if (!serverVersion) return;
    if (serverVersion !== APP_VERSION && !shownRef.current) {
      shownRef.current = true;
      versionUpdateToast(t("available"), {
        label: t("refresh"),
        onClick: () => {
          window.location.reload();
        },
      });
    }
  }, [serverVersion, t]);

  return null;
}
